import { RobotVacuumVariantIcon } from './RobotVacuumVariantIcon';

/**
 * author: GreenTurtwig
 * id C7938632-FA58-4686-9B82-5E9CCDD0EC83
 * name robot-vacuum-variant
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-vacuum-variant.svg
 * tags
 * - Home Automation 
 */
export const NeatoIcon = RobotVacuumVariantIcon;
export default NeatoIcon